<template>
  <div>
    <Toast></Toast>
    <ConfirmDialog></ConfirmDialog>
      <div class="modal-content">
        <div class="modal-body mb-1 pt-2">
          <div class="table-responsive">
            <DataTable
              stripedRows
              headerStyle="text-align: center"
              class="p-datatable-customers"
              :lazy="true"
              :rowHover="true"
              :loading="loading"
              :value="patResSumm"
              :paginator="true"
              :rows="10"
              :totalRecords="totalrows"
              @page="onPage($event)"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              :rowsPerPageOptions="[10, 20, 50, 100]"
              responsiveLayout="scroll"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            >
              <ColumnGroup type="header">
                <Column field="IsCaptured" header="Action">
                  <template #body="slotProps">
                    <InputSwitch v-model="slotProps.data.isCaptured" @click="isCapturedClick(slotProps.data)"/>
                    <!-- {{ showHistDate(slotProps.data.createdAt) }} -->
                  </template>
                </Column>
              </ColumnGroup>

              <Column field="resourceStrId" header="Resource ID"></Column>
              <Column field="name" header="Resource Name"></Column>
              <Column field="available" header="Available"></Column>
              <Column field="qty" header="Total"></Column>
            </DataTable>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-success waves-effect col-12"
            @click="updateResourcesClick()"
          >
            Update Resources
          </button>
        </div>
      </div>
  </div>
</template>

<script src="./ResourceComponent"></script>


<style lang="scss" scoped>
::v-deep(.p-paginator) {
  .p-paginator-current {
    margin-left: auto;
  }
}
::v-deep(.p-progressbar) {
  height: 0.5rem;
  background-color: #d8dadc;
  .p-progressbar-value {
    background-color: #607d8b;
  }
}
::v-deep(.p-datepicker) {
  min-width: 25rem;
  td {
    font-weight: 400;
  }
}
::v-deep(.p-datatable.p-datatable-customers) {
  .p-datatable-header {
    padding: 1rem;
    text-align: center;
    font-size: 1.5rem;
  }
  .p-paginator {
    padding: 1rem;
  }
  .p-paginator .p-paginator-pages .p-paginator-page {
    background-color: transparent;
    border: 1px;
    border-color: dimgray;
    color: #495057;
    min-width: 2.357rem;
    height: 2.357rem;
    margin: 0.143rem;
    box-shadow: none;
    border-radius: 0px;
  }
  .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    background: darkorange;
    border: 1px;
    // border-color: darkorange;
    color: white;
  }
  .p-datatable-thead > tr > th {
    text-align: center;
    background-color: #000000;
    color: white;
    font-weight: 700;
  }
  .p-datatable-tbody > tr > td {
    cursor: auto;
  }
  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}
</style>